import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UIValueSlider',
  props: {
    value: null,
    min: { default: 0 },
    max: { default: 1 },
    step: { default: 0.1 },
    parentHasGroup: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'input', value: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: number, min: number, max: number, step: number, parentHasGroup: boolean };

// To be used with v-model
// Generally v-model requires modelValue and update:modelValue
// But in vue 2.7 with composition API, we use value and input event





const localValue = computed({
  get(): number {
    // Ensure the value is within bounds on initial load or prop change
    return Math.max(props.min, Math.min(props.max, props.value))
  },
  set(newValue: string | number) {
    let numValue = typeof newValue === 'string' ? parseFloat(newValue) : newValue
    // Clamp the value between min and max
    numValue = Math.max(props.min, Math.min(props.max, numValue))
    // Ensure the value aligns with the step
    const clampedValue = props.min + Math.round((numValue - props.min) / props.step) * props.step
    const finalValue = Math.max(props.min, Math.min(props.max, clampedValue)) // Re-clamp after step adjustment

    if (finalValue !== props.value) {
      emits('input', Number(finalValue.toFixed(1)))
    }
  }
})

const rangeTrackRight = computed(() => {
  const range = Number(props.max) - Number(props.min)
  if (range <= 0) return '0%' // Avoid division by zero
  const percentage = ((Number(props.max) - Number(localValue.value)) / range) * 100
  return `${Math.max(0, Math.min(100, percentage))}%` // Clamp between 0 and 100
})

const valueStyle = computed(() => {
  const range = Number(props.max) - Number(props.min)
  if (range <= 0) return { right: '0%', transform: 'translate(0%, 100%)' }
  const percentage = ((Number(props.max) - Number(localValue.value)) / range) * 100
  const clampedPercentage = Math.max(0, Math.min(100, percentage))
  return {
    right: `${clampedPercentage}%`,
    transform: `translate(${clampedPercentage / 2}%, 100%)` // Adjust transform based on right position
  }
})

const handleInput = (event: Event) => {
  const target = event.target as HTMLInputElement
  let numValue = parseFloat(target.value)

  // Check for NaN in case of invalid input like '--' or empty string during typing
  if (isNaN(numValue) && target.value !== '') {
    return
  } else if (isNaN(numValue) && target.value === '') {
    // Allow empty string to proceed, blur will handle setting to min
    // No immediate clamping needed here, just pass to setter
  } else if (numValue > props.max) {
    // If input value exceeds max, clamp it immediately
    numValue = props.max
    target.value = numValue.toString() // Update input visually
  } else if (numValue < props.min) {
    // If input value is below min, clamp it immediately
    numValue = props.min
    target.value = numValue.toString() // Update input visually
  }

  localValue.value = target.value // Pass the string value from the input
}

const handleBlur = (event: FocusEvent) => {
  const target = event.target as HTMLInputElement
  if (target.value === '') {
    // If input is empty on blur, set it to the minimum value via the computed setter
    localValue.value = props.min
  } else {
    // If input is not empty, re-run the value through the setter on blur
    // to ensure it's clamped and aligned with the step.
    localValue.value = target.value
  }
}

return { __sfc: true,props, emits, localValue, rangeTrackRight, valueStyle, handleInput, handleBlur }
}

})